// @flow
import {sanitizePhoneNumber} from '../phone';

export const generateWhatsappLink = (whatsappNumber: string, text?: string) => {
  const cleanPhone = sanitizePhoneNumber(whatsappNumber);
  if (text) {
    return `https://wa.me/${cleanPhone}?text=${encodeURIComponent(text)}`;
  }

  return `https://wa.me/${cleanPhone}`;
};

export const generateMailLink = (
  mailto: string,
  subject: string,
  body: string,
  cc?: string
) => `mailto:${mailto}?subject=${subject}&body=${body}${cc ? '&cc=' + cc : ''}`;

export function replaceTemplate(template: string, data: Object) {
  if (template)
    return template.replace(/{{(\w*)}}/g, function(m, key) {
      return data.hasOwnProperty(key) ? data[key] : m;
    });
  return '';
}
